import React, { useCallback } from 'react';
import { businessFilterStyles } from './styled';
import { SegmentedButton } from '@ontruck/orc';
import cx from 'classnames';

export const options = {
  export: { value: 'COLLECTION', label: 'EXPORTACION' },
  import: { value: 'DISTRIBUTION', label: 'IMPORTACION' },
};

const BusinessFilter = ({ className, value, onChange, marginRight }) => {
  const handleChange = useCallback(
    (_, { value: selectedValue }) => {
      onChange(selectedValue);
    },
    [onChange]
  );

  const handleClick = useCallback(
    (optionValue) => () => {
      if (optionValue === value) {
        onChange(null);
      }
    },
    [value, onChange]
  );

  return (
    <div className={cx(className, { 'margin-right': marginRight })}>
      <SegmentedButton.Parent value={value} onChange={handleChange}>
        <SegmentedButton.Child
          onClick={handleClick(options.export.value)}
          value={options.export.value}
          label={options.export.label}
        />
        <SegmentedButton.Child
          onClick={handleClick(options.import.value)}
          value={options.import.value}
          label={options.import.label}
        />
      </SegmentedButton.Parent>
    </div>
  );
};

BusinessFilter.filterName = 'BusinessFilter';

export default businessFilterStyles(BusinessFilter);
